import React from 'react';
import { Field, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../Core';

let ResultsSectionBase: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field input={<TextOutput />} name="Results.AverageVaneShearStrengthText" />
      </ListFieldSection>
    </>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);

export default ResultsSection;
export { ResultsSection };
